import axios from 'axios'
import config from '../config'

export default {
    getMailServiceSettings(currentPage, perPage) {
        return axios.get(config.publicPath + 'mail_service_settings', {
            params: {_page: currentPage, itemsPerPage: perPage},
        });
    },
    createMailServiceSettings(formData) {
        return axios.post(config.publicPath + 'mail_service_settings', formData, {
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            },
        });
    },
    getMailServiceSetting(id) {
        return axios.get(config.publicPath + 'mail_service_settings/' + id, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    },
    updateMailServiceSettings(id, formData) {
        return axios.put(config.publicPath + 'mail_service_settings/' + id, formData, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    },
    deleteMailServiceSetting(id) {
        return axios.delete(config.publicPath + 'mail_service_settings/' + id);
    }
}